import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import animate from "animate.css";
import BaiduMap from 'vue2-baidu-map'

//css3动画
Vue.use(animate);
Vue.config.productionTip = false;
// 引入UI库
Vue.use(ElementUI);
Vue.use(BaiduMap, {
  ak: 'YIEYe0fRWiu4IBsMaWPAnRDY4cwub7fw'
})
Vue.prototype.$bus = new Vue()
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
